import { AppState } from 'Store'

const getOne = (state: AppState) => state.registratorCabinet.drs.office
const getUnits = (state: AppState) => state.registratorCabinet.drs.units
const getCurrentParams = (state: AppState) => state.registratorCabinet.drs.requestParams

export const drsSelectors = {
	getOne,
	getCurrentParams,
	getUnits,
}
